// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3j4Dd","sendOtp":"AuthorizeToLogin_sendOtp__2hsB0"};